module.exports = __webpack_public_path__ + "static/media/16_plantilla_cuadrada_combo_simple_cp_stills_pet_500_cepita_fresh_nar.43fe7ec3.png";